<sew-form
    *oscNgUse="formElementsContext as contactForm"
    [attr.no-margin]="noMargin ? '' : null"
    [attr.no-grid]="noGrid ? '' : null"
>
    @if (contactForm && contactForm.length && contactForm[0].name) {
        <sew-richtext>
            <sew-wizard>
                @for (step of contactForm; track step; let index = $index) {
                    <sew-wizard-item
                        [stepIndex]="index + 1"
                        [completed]="index + 1 < stepperIndex"
                        [active]="index + 1 === stepperIndex"
                    >
                        <button type="button">{{ step.name }}</button>
                    </sew-wizard-item>
                }
            </sew-wizard>
        </sew-richtext>
    }

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        @for (step of contactForm; track step; let index = $index) {
            <fieldset [formGroupName]="step.id" [style.display]="index + 1 === stepperIndex ? '' : 'none'">
                @for (row of step.rows; track row) {
                    <sew-form-row [attr.split]="row.elements.length > 1 || row.fill === true ? '' : null">
                        @for (formElement of row.elements; track formElement) {
                            @if (formElement.visible) {
                                @switch (formElement.type) {
                                    @case ('inputField') {
                                        <sew-input
                                            [class.sew-ws-dark]="darkTheme"
                                            [attr.ws]="ws ? '' : null"
                                            [status]="
                                                isElementInvalid(step.id, formElement.name) ? 'error' : null
                                            "
                                        >
                                            <label [attr.for]="formElement.id">{{ formElement.label }}</label>
                                            <input
                                                type="text"
                                                [id]="formElement.id"
                                                [formControlName]="formElement.name"
                                                [autocomplete]="
                                                    isAutocompleteOff(step.id, formElement.name)
                                                        ? 'off'
                                                        : 'on'
                                                "
                                            />
                                            <div class="error-text">
                                                {{ formElement.errorMsg }}
                                            </div>
                                        </sew-input>
                                    }
                                    <!--TODO: Konfiguration auslagern in CMS-->
                                    @case ('date') {
                                        <sew-input
                                            [class.sew-ws-dark]="darkTheme"
                                            [attr.ws]="ws ? '' : null"
                                            [datepicker]="true"
                                            [datepickerConfig]="datepickerConfig"
                                            [status]="
                                                isElementInvalid(step.id, formElement.name) ? 'error' : null
                                            "
                                        >
                                            <label [attr.for]="formElement.id">{{ formElement.label }}</label>
                                            <input
                                                type="text"
                                                [id]="formElement.id"
                                                [formControlName]="formElement.name"
                                                autocomplete="off"
                                            />
                                            <div class="error-text">
                                                {{ formElement.errorMsg }}
                                            </div>
                                        </sew-input>
                                    }
                                    @case ('textArea') {
                                        <sew-input
                                            [class.sew-ws-dark]="darkTheme"
                                            [attr.ws]="ws ? '' : null"
                                            [status]="
                                                isElementInvalid(step.id, formElement.name) ? 'error' : null
                                            "
                                        >
                                            <label [attr.for]="formElement.id">{{ formElement.label }}</label>
                                            <textarea
                                                type="text"
                                                [id]="formElement.id"
                                                [formControlName]="formElement.name"
                                            ></textarea>
                                            <div class="error-text">
                                                {{ formElement.errorMsg }}
                                            </div>
                                        </sew-input>
                                    }
                                    @case ('checkBoxGroup') {
                                        <sew-checkbox-group
                                            [headline]="formElement.label"
                                            [class.sew-theme-dark]="darkTheme"
                                        >
                                            @for (element of formElement.elements; track element) {
                                                <sew-checkbox
                                                    [class.sew-ws-dark]="darkTheme"
                                                    [attr.ws]="ws ? '' : null"
                                                    [status]="
                                                        isElementInvalid(step.id, formElement.name)
                                                            ? 'error'
                                                            : null
                                                    "
                                                >
                                                    <label [attr.for]="element.id">
                                                        <sew-ws-richtext small>
                                                            <p [innerHTML]="element.label | safeHtml"></p>
                                                        </sew-ws-richtext>
                                                    </label>
                                                    <input
                                                        type="checkbox"
                                                        [id]="element.id"
                                                        [formControlName]="formElement.name"
                                                    />
                                                    <div class="error-text">
                                                        {{ formElement.errorMsg }}
                                                    </div>
                                                </sew-checkbox>
                                            }
                                        </sew-checkbox-group>
                                    }
                                    @case ('comboBox') {
                                        <sew-combobox
                                            [comboboxId]="formElement.id"
                                            [class.sew-ws-dark]="darkTheme"
                                            [attr.ws]="ws ? '' : null"
                                            [placeholder]="formElement.label"
                                            [status]="
                                                isElementInvalid(step.id, formElement.name) ? 'error' : null
                                            "
                                            [hideNoSelectionOption]="true"
                                        >
                                            <select
                                                [formControlName]="formElement.name"
                                                title="{{ formElement.label }}"
                                            >
                                                @for (option of formElement.options; track option) {
                                                    <option [value]="option.value">
                                                        {{ option.name }}
                                                    </option>
                                                }
                                            </select>
                                            <div class="error-text">
                                                {{ formElement.errorMsg }}
                                            </div>
                                        </sew-combobox>
                                    }
                                    @case ('fileUpload') {
                                        <sew-file-upload
                                            [class.sew-ws-dark]="darkTheme"
                                            [attr.ws]="ws ? '' : null"
                                            [button]="'CREATE_PAGE.OPEN_EXPLORER' | translate"
                                            [manual]="'CREATE_PAGE.FILEUPLOAD_MANUAL' | translate"
                                            [supported]="formElement.acceptedFileTypes"
                                            [allowedMimeTypes]="allowedMimeTypes"
                                            [error]="isElementInvalid(step.id, formElement.name)"
                                            (fileschange)="updateFileList($event)"
                                        >
                                            <label [attr.for]="formElement.id">{{ formElement.label }}</label>
                                            <input
                                                [id]="formElement.id"
                                                type="file"
                                                multiple
                                                accept="{{ formElement.acceptedFileTypes }}"
                                                [formControlName]="formElement.name"
                                            />
                                        </sew-file-upload>
                                    }
                                    @case ('richTextEditor') {
                                        <sew-richtext-editor
                                            [class.sew-ws-dark]="darkTheme"
                                            [attr.ws]="ws ? '' : null"
                                            [label]="formElement.label"
                                            [formControlName]="formElement.name"
                                            [error]="isElementInvalid(step.id, formElement.name)"
                                        >
                                            <div class="error-text">
                                                {{ formElement.errorMsg }}
                                            </div>
                                        </sew-richtext-editor>
                                    }
                                    @case ('captcha') {
                                        <div class="captcha">
                                            <img [src]="captchaImage" (click)="getCaptcha()" width="150px" />
                                            <sew-input
                                                [status]="
                                                    isElementInvalid(step.id, formElement.name)
                                                        ? 'error'
                                                        : null
                                                "
                                                [class.sew-ws-dark]="darkTheme"
                                                [attr.ws]="ws ? '' : null"
                                            >
                                                <label [attr.for]="formElement.id">{{
                                                    formElement.label
                                                }}</label>
                                                <input
                                                    type="text"
                                                    [id]="formElement.id"
                                                    [formControlName]="formElement.name"
                                                />
                                                <div class="error-text">
                                                    {{ formElement.errorMsg }}
                                                </div>
                                            </sew-input>
                                        </div>
                                    }
                                    @case ('radioGroup') {
                                        <sew-radio-group
                                            [class.sew-ws-dark]="darkTheme"
                                            [attr.ws]="ws ? '' : null"
                                            [headline]="formElement.label"
                                            direction="horizontal"
                                        >
                                            @for (radioButton of formElement.elements; track radioButton) {
                                                <sew-radio>
                                                    <input
                                                        [name]="formElement.name"
                                                        type="radio"
                                                        [id]="radioButton.id"
                                                        [value]="radioButton.value"
                                                        [formControlName]="formElement.name"
                                                    />
                                                    <label [for]="radioButton.id">{{
                                                        radioButton.label
                                                    }}</label>
                                                </sew-radio>
                                            }
                                        </sew-radio-group>
                                    }
                                    @case ('paragraph') {
                                        <sew-markdown
                                            ws
                                            [class.sew-ws-dark]="darkTheme"
                                            [markdown]="formElement.label"
                                        ></sew-markdown>
                                    }
                                }
                            }
                        }
                    </sew-form-row>
                }
                @if (index + 1 === stepperIndex) {
                    <div class="actionbar" [class.actionbar-initial]="stepperIndex === 1">
                        @if (stepperIndex > 1) {
                            <sew-button
                                hierarchy="secondary"
                                icon=""
                                class="primary"
                                (click)="stepperIndex = stepperIndex - 1"
                            >
                                <button type="button">{{ step.backText }}</button>
                            </sew-button>
                        }
                        @if (ws) {
                            <div (mouseenter)="setControlsInStepTouched(step.id)">
                                @if (index + 1 < contactForm.length) {
                                    <sew-ws-button
                                        [class.sew-ws-dark]="darkTheme"
                                        [attr.full-width]="buttonFullWidth ? '' : null"
                                        (click)="stepperIndex = stepperIndex + 1"
                                    >
                                        <button type="button" [disabled]="isStepInvalid(step.id)">
                                            {{ step.nextText }}
                                        </button>
                                    </sew-ws-button>
                                }
                            </div>
                            <div (mouseenter)="setControlsInStepTouched(step.id)">
                                @if (index + 1 === contactForm?.length) {
                                    <sew-ws-button
                                        [class.sew-ws-dark]="darkTheme"
                                        [attr.full-width]="buttonFullWidth ? '' : null"
                                    >
                                        <button type="submit" [disabled]="!form.valid">
                                            {{ step.nextText }}
                                        </button>
                                    </sew-ws-button>
                                }
                            </div>
                        } @else {
                            <div (mouseenter)="setControlsInStepTouched(step.id)">
                                @if (index + 1 < contactForm.length) {
                                    <sew-button
                                        [class.sew-ws-dark]="darkTheme"
                                        hierarchy="primary"
                                        icon=""
                                        class="primary"
                                        (click)="stepperIndex = stepperIndex + 1"
                                    >
                                        <button type="button" [disabled]="isStepInvalid(step.id)">
                                            {{ step.nextText }}
                                        </button>
                                    </sew-button>
                                }
                            </div>
                            <div (mouseenter)="setControlsInStepTouched(step.id)">
                                @if (index + 1 === contactForm?.length) {
                                    <sew-button
                                        hierarchy="primary"
                                        [class.sew-ws-dark]="darkTheme"
                                        icon=""
                                        class="primary"
                                    >
                                        <button type="submit" [disabled]="!form.valid">
                                            {{ step.nextText }}
                                        </button>
                                    </sew-button>
                                }
                            </div>
                        }
                    </div>
                }
            </fieldset>
        }
    </form>
</sew-form>
